import React from 'react';
import { CheckCircle, Clock, Award, Users } from 'lucide-react';
import { useGoogleReviews } from '../hooks/useGoogleReviews';

const About = () => {
  const { rating, loading } = useGoogleReviews();
  const formattedRating = rating.toFixed(1);
  const features = [
  {
    icon: CheckCircle,
    title: "Qualidade Comprovada",
    description: "Milhares de clientes atendidos. Equipamentos modernos e materiais premium."
  },
  {
    icon: Clock,
    title: "Rapidez que Impressiona",
    description: "Maioria dos servi\xE7os prontos no MESMO DIA ou em at\xE9 24h. Urg\xEAncia? A gente resolve!"
  },
  {
    icon: Award,
    title: "Preço Honesto",
    description: "Sem surpresas! Orçamento transparente e valor justo. Compare e comprove!"
  },
  {
    icon: Users,
    title: "Atendimento Nota 10",
    description: "Equipe experiente e atenciosa. Seu problema é nosso problema até resolver!"
  }];


  return (
    <section id="sobre" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-block mb-4 px-4 py-2 bg-[#1e3a8a]/10 rounded-full">
              <p className="text-[#1e3a8a] text-sm font-semibold">SOBRE NÓS</p>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Por Que Escolher a Gráfica Rápida Infortech?
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Há mais de 10 anos atendendo <span className="font-semibold text-[#1e3a8a]">Fortaleza e região</span>, somos referência em qualidade, rapidez e preço justo.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Seja para impressão urgente, brindes personalizados ou conserto do seu computador, <span className="font-semibold text-[#1e3a8a]">você encontra tudo aqui</span> com atendimento que realmente se importa com seu problema.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6 mb-8">
              <div className="text-center p-4 bg-gradient-to-br from-[#1e3a8a]/5 to-[#3b82f6]/5 rounded-lg">
                {loading ? (
                  <p className="text-3xl font-bold text-[#1e3a8a] mb-1 animate-pulse">...</p>
                ) : (
                  <p className="text-3xl font-bold text-[#1e3a8a] mb-1">{formattedRating}</p>
                )}
                <p className="text-sm text-gray-600">Avaliação Google</p>
              </div>
              <div className="text-center p-4 bg-gradient-to-br from-[#f97316]/5 to-[#fb923c]/5 rounded-lg">
                <p className="text-3xl font-bold text-[#f97316] mb-1">+10.000</p>
                <p className="text-sm text-gray-600">Serviços realizados</p>
              </div>
            </div>
          </div>

          {/* Right Content - Features */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {features.map((feature, index) => {
              const IconComponent = feature.icon;
              return (
                <div
                  key={index}
                  className="p-6 bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-xl hover:shadow-lg transition-all duration-300 hover:-translate-y-1">

                  <div className="w-12 h-12 bg-gradient-to-br from-[#1e3a8a]/10 to-[#3b82f6]/10 rounded-lg flex items-center justify-center mb-4">
                    <IconComponent className="w-6 h-6 text-[#1e3a8a]" />
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {feature.description}
                  </p>
                </div>);

            })}
          </div>
        </div>
      </div>
    </section>);

};

export default About;